import React from "react";
import { useTranslation } from "react-i18next";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaFacebook, FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  const { t, i18n } = useTranslation();
  return (
    <div className="footer w-full">
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-1/3 footer-copywright">
          <h3>{t("Designed and Developed by Ranvir Gorai")}</h3>
        </div>
        <div className="w-full md:w-1/3 footer-copywright">
          <h3>{t("Copyright")} © {year} RG</h3>
        </div>
        <div className="w-full md:w-1/3 footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://www.facebook.com/gorairanvir"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/ranvirgorai/"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
            {/* <li className="social-icons">
              <a href="https://twitter.com/Ranvirgorai" style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                <AiOutlineTwitter />
              </a>
            </li> */}
            {/* <li className="social-icons">
              <a href="https://github.com/ranvirgorai/" style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                <AiFillGithub />
              </a>
            </li> */}
            {/* <li className="social-icons">
              <a href="https://www.linkedin.com/in/ranvirgorai/" style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Footer;
